import { ActionsUnion, createAction } from '../helpers';

export enum ECustomerCareActionType {
  GET_FAQ = 'CUSTOMER_CARE/GET_FAQ',
  GET_FAQ_SUCCESS = 'CUSTOMER_CARE/GET_FAQ_SUCCESS',
}

export const customerCareActions = {
  getFAQ: () => createAction(ECustomerCareActionType.GET_FAQ),
  getFAQSuccess: () => createAction(ECustomerCareActionType.GET_FAQ_SUCCESS),
};

export type TCustomerCareAction = ActionsUnion<typeof customerCareActions>;
